import React from "react";

import dayjs from "dayjs";

const ECD = (props) => {
    return (
        <>
            {
                props.ecd ?
                    <p style={{ color: "black" }}>Your estimated completion date is <b>{dayjs(props.ecd.toDate()).format('MM/DD/YYYY')}</b>. This date is an estimate only. This date may change based on part delivery, additional damages found, and other circumstances that are beyond our control such as a delay with a sublet vendor. Our goal is to get your vehicle back to you as quick as possible while maintaining the most proffessional repair possible. A member of our staff will call you as soon as your vehicle is ready to pick up.</p> :
                    <p style={{ color: "black" }}>Your estimated completion date is not available at this time. Please check back later for an update. This usually occurs when the vehicle has been here for less than 48 hours.</p>
            }
        </>
    )
}

export default ECD